import { useEffect } from 'react'

interface UseTagOutsideClickDismissOptions {
  mode: 'read' | 'edit'
  inputText: string
  isMutating: boolean
  exitEditMode: () => void
  scopeSelector: string
}

export const useTagOutsideClickDismiss = (
  options: UseTagOutsideClickDismissOptions,
) => {
  const { mode, inputText, isMutating, exitEditMode, scopeSelector } = options

  useEffect(() => {
    if (mode !== 'edit') {
      return
    }

    const handleMouseDown = (e: MouseEvent) => {
      if (isMutating) {
        return
      }

      if (inputText.trim()) {
        return
      }

      const target = e.target as HTMLElement | null

      if (target?.closest(scopeSelector)) {
        return
      }

      exitEditMode()
    }

    document.addEventListener('mousedown', handleMouseDown)

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
    }
  }, [mode, inputText, isMutating, exitEditMode, scopeSelector])
}
